const initState = {};

const campaignReducer = (state = initState, action) => {
  return state;
}

export default campaignReducer;